<p-accordion (onOpen)="openAccordion($event)">
  <p-accordionTab header="{{'Configuration.CRM.Account_Type' | transloco}}" [selected]="true">
    <p-table [value]="accountType" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6" pReorderableColumn>Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2" pReorderableColumn>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeAccountTypeDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" (click)="showEditAccountData(data,
              accountDataTypes[0])" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span *ngIf="data.organizationId != 0 && !data.isDefault" class="btnBars p-mr-0"
              (click)="delAccountType(data)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Account_Source' | transloco}}">
    <p-table [value]="accountSource" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6" pReorderableColumn>Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2" pReorderableColumn>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeAccountSourceDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[1])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault"
              (click)="delAccountSource(data)" pTooltip="Delete" tooltipPosition="top"><i
                class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Rating' | transloco}}">
    <p-table [value]="ratings" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeRatingDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[2])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delRating(data)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Timezone' | transloco}}">
    <p-table [value]="timeZoneList" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data,
              accountDataTypes[3])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="delTimezone(data)" pTooltip="Delete" tooltipPosition="top"><i
                class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Number_of_Employees' | transloco}}">
    <p-table [value]="employeesCounts" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeEmployeesCountDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[4])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault"
              (click)="delEmployeesNo(data)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Estimated_Annual_Revenue' | transloco}}">
    <p-table [value]="revenue" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeRevenueDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[5])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delRevenue(data)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Ownership_Type' | transloco}}">
    <p-table [value]="ownerships" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeOwnershipDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[6])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault"
              (click)="delOwnership(data)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Industry' | transloco}}">
    <p-table [value]="industries" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeIndustryDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0" (click)="showEditAccountData(data,
              accountDataTypes[7])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="data.organizationId != 0 && !data.isDefault" (click)="delIndustry(data)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Account_Email' | transloco}}">
    <p-table [value]="accountEmail" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data,
              accountDataTypes[8])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delAccountEmail(index)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Account_Phone' | transloco}}">
    <p-table [value]="accountPhone" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-10">Name</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data,
              accountDataTypes[9])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delAccountPhone(index)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="{{'Configuration.CRM.Account_Social_Profile' | transloco}}">
    <p-table [value]="accountSocial" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-10">Name </th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-10">{{data.name}}</td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data,
              accountDataTypes[10])" pTooltip="Edit" tooltipPosition="top"><i class="pi
                pi-pencil"></i></span>
            <span class="btnBars p-mr-0" *ngIf="!data.systemGenerated" (click)="delAccountSocial(index)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Active Reason">
    <p-table [value]="activeReason" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-6">{{ data.name }}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data, accountDataTypes[11])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, accountDataTypes[11])"
              pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Inactive Reason">
    <p-table [value]="inactiveReason" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr style="cursor: move;">
          <td class="p-col-6">{{ data.name }}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeActiveInactiveDefault(data)"></p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span class="btnBars p-mr-0" (click)="showEditAccountData(data, accountDataTypes[12])" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="deleteActiveInactiveReason(data, accountDataTypes[12])"
              pTooltip="Delete" tooltipPosition="top" *ngIf="data.isDefault == false"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Address Type">
    <p-table [value]="addressTypes" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeAddressTypeDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span *ngIf="(data.organizationId != 0) && !['Billing', 'Shipping'].includes(data.name)"
              class="btnBars p-mr-0" (click)="showEditAccountData(data, accountDataTypes[13])" pTooltip="Edit"
              tooltipPosition="top">
              <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="(data.organizationId != 0) && !['Billing', 'Shipping'].includes(data.name)&& !data.isDefault"
              class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" (click)="deleteAddressType(data)">
              <i class="pi pi-trash"></i>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  <p-accordionTab header="Address Class">
    <p-table [value]="addressClasses" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Is Default</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">{{data.name}}</td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2">
            <p-radioButton class="p-mr-2" [disabled]="data.isDefault || data.statusId==2" [value]="true"
              [(ngModel)]="data.isDefault" (onClick)="makeAddressClassDefault(data)">
            </p-radioButton>
            {{data.isDefault ? answertypeConstants.Yes: answertypeConstants.No}}
          </td>
          <td class="p-col-2 action">
            <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0"
              (click)="showEditAccountData(data, accountDataTypes[14])" pTooltip="Edit" tooltipPosition="top">
              <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="data.organizationId != 0 && !data.isDefault" class="btnBars p-mr-0" pTooltip="Delete"
              tooltipPosition="top" (click)="deleteAddressClass(data)">
              <i class="pi pi-trash"></i>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
  
  <!-- ---------------------------------tags added -->
  <p-accordionTab header="Tags">
    <p-table [value]="tagList" [scrollable]="true" scrollHeight="180px">
      <ng-template pTemplate="header">
        <tr>
          <th style="max-width:3rem"></th>
          <th class="p-col-6">Name</th>
          <th class="p-col-2">Is Active</th>
          <th class="p-col-2">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td style="max-width:3rem" class="action">
            <span class="pi pi-bars"></span>
          </td>
          <td class="p-col-6">
            <p-tag [value]="data?.name" class="p-ml-2" [style]="{'background-color': data?.color}"></p-tag>
          </td>
          <td class="p-col-2">{{ data.statusId==1 ? answertypeConstants.Yes : answertypeConstants.No }}</td>
          <td class="p-col-2 action">
            <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" (click)="showEditTag(data)" pTooltip="Edit"
              tooltipPosition="top">
              <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="data.organizationId != 0" class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"
              (click)="deleteTag(data)">
              <i class="pi pi-trash"></i>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-accordionTab>
</p-accordion>

<p-dialog header="{{addEditAccountHeader}}" [modal]="true" [(visible)]="displayAddAccountData" [style]="{width: '50vw'}"
  [baseZIndex]="10000">
  <div class="p-grid">
    <div class="p-col-12" *ngIf="showAddFieldDataArea">
      <label for="type">{{'Configuration.CRM.Fields_Type' | transloco}} <span style="color: red;">*</span></label>
      <p-dropdown [options]="accountDataTypes" [(ngModel)]="selectedAccountDataType" optionLabel="name"
        placeholder="{{'Configuration.CRM.Select_Field_Type' | transloco}}"
        [ngClass]="{ 'p-invalid': formSubmitted && !selectedAccountDataType}" [ngModelOptions]="{standalone: true}"
        appendTo="body" (onChange)="getAccountDataType()"></p-dropdown>
      <small *ngIf="formSubmitted && !selectedAccountDataType" class="p-invalid">
        {{'Configuration.CRM.Fields_Type_is_required' | transloco}}
      </small>
    </div>

    <div class="p-col-12" *ngIf="showEditFieldDataArea">
      <div class="header">
        <h5 class="p-mb-0">{{'Configuration.CRM.Fields_Name' | transloco}} -- {{accountDataTypes[accountTypeId].name}}
          <p-inputSwitch *ngIf="showActiveBtn" class="header-switch" [(ngModel)]="accountDataTemp.isActive"
            [ngModelOptions]="{standalone: true}" [disabled]="accountDataTemp && accountDataTemp?.isDefault">
          </p-inputSwitch>
        </h5>
      </div>
    </div>

    <div class="p-col-12"  *ngIf="subscriptionLimitReached">
        <app-subscription-limit-message
            [subscriptionLimit]="subscriptionLimit"
            [moduleName]="'Tags'">
        </app-subscription-limit-message>
    </div>

    <ng-container *ngIf="!subscriptionLimitReached">
        <div class="p-col-12">
        <label for="name">{{'Configuration.CRM.Name' | transloco}} <span style="color: red;">*</span></label>
        <input type="text" pInputText [ngModel]="accountDataTemp?.name" #dataName="ngModel" [ngClass]="{ 'p-invalid': formSubmitted && (!accountDataTemp?.name ||
            invalidData == true)}" (ngModelChange)="accountDataTemp.name= $event">
        <small *ngIf="formSubmitted && !accountDataTemp?.name" class="p-invalid">
            {{'Configuration.CRM.Name_is_required' | transloco}}
        </small>
        <small *ngIf="invalidData == true" class="p-invalid">
            {{'Configuration.CRM.Name_exists_in_the_list' | transloco}}
        </small>
        </div>
        <div *ngIf="selectedAccountDataType?.id != 15" class="p-col-12">
        <label for="name">{{'Configuration.CRM.Description' | transloco}}</label>
        <input type="text" pInputText style="width: 100%;" [ngModel]="accountDataTemp?.description"
            (ngModelChange)="accountDataTemp.description= $event">
        </div>
        <div *ngIf="selectedAccountDataType?.id == 15" class="p-col-12">
        <label for="name">Tag Color</label>
        <p-colorPicker [(ngModel)]="accountDataTemp.color" appendTo="body"></p-colorPicker>
        </div>
    </ng-container>
  </div>
  <ng-template pTemplate="footer">
    <button pButton
      (click)="displayAddAccountData = false; formSubmitted = false; dataName.reset(); invalidData = false;"
      label="{{'Configuration.CRM.Cancel' | transloco}}" class="p-button-secondary"></button>
    <button *ngIf="!subscriptionLimitReached" pButton (click)="saveAccountDataAdd();" label="{{'Configuration.CRM.Save' | transloco}}"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Edit Tags" [modal]="true" [(visible)]="displayEditTag" [style]="{width: '50vw'}" [baseZIndex]="10000">
  <div class="p-col-12">
    <div class="header">
      <h5 class="p-mb-0">{{'Configuration.CRM.Fields_Name' | transloco}} -- Tags
        <p-inputSwitch class="header-switch" [ngModelOptions]="{standalone: true}" [(ngModel)]="tempTag.isActive">
        </p-inputSwitch>
      </h5>
    </div>
  </div>
  <div class="card" style="min-height: 300px;">
    <div class="p-grid">
      <div class="p-col-12">
        <label>Tag Name</label>
        <input type="text" pInputText [(ngModel)]="tempTag.name">
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12">
        <label>Tag color</label>
        <p-colorPicker [(ngModel)]="tempTag.color" appendTo="body"></p-colorPicker>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Cancel" (click)='displayEditTag=false' class="p-button-secondary"></button>
    <button pButton (click)="saveTag();" label="Save"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
